export const API_ADDRESS = "https://api.ncy31qred.cloud/admin"
export const PROFILE_IMAGE_URL = "https://api.ncy31qred.cloud/image/profile"
export const ITEM_IMAGE_URL = "https://api.ncy31qred.cloud/image/item"